var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { id: "Icone Mais Positivo" } }, [
        _c("path", {
          attrs: {
            id: "Mask",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M15 13H13V15C13 15.55 12.55 16 12 16C11.45 16 11 15.55 11 15V13H9C8.45 13 8 12.55 8 12C8 11.45 8.45 11 9 11H11V9C11 8.45 11.45 8 12 8C12.55 8 13 8.45 13 9V11H15C15.55 11 16 11.45 16 12C16 12.55 15.55 13 15 13ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
            fill: _vm.color
          }
        }),
        _c(
          "mask",
          {
            staticStyle: { "mask-type": "luminance" },
            attrs: {
              id: _vm.maskId,
              maskUnits: "userSpaceOnUse",
              x: "2",
              y: "2",
              width: "20",
              height: "20"
            }
          },
          [
            _c("path", {
              attrs: {
                id: "Mask_2",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d:
                  "M15 13H13V15C13 15.55 12.55 16 12 16C11.45 16 11 15.55 11 15V13H9C8.45 13 8 12.55 8 12C8 11.45 8.45 11 9 11H11V9C11 8.45 11.45 8 12 8C12.55 8 13 8.45 13 9V11H15C15.55 11 16 11.45 16 12C16 12.55 15.55 13 15 13ZM12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2Z",
                fill: "white"
              }
            })
          ]
        ),
        _c("g", { attrs: { mask: "url(#" + _vm.maskId + ")" } }, [
          _c("g", { attrs: { id: "🎨 Color" } }, [
            _c("rect", {
              attrs: { id: "Base", width: "24", height: "24", fill: _vm.color }
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }